// LQC-2949 - minimum traded size. Bonds trade in 10,000s; the user can still override
// to any whole number (see NominalInput roundingStep). Futures are whole contracts, which
// ContractCountInput already enforces.
export const BOND_SIZE_ROUNDING_STEP = 10000;

// Nearest step, never below one step: a size that rounds to 0 is not a trade.
export function returnRoundedSize(value: number, step: number): number {
  return Math.max(step, Math.round(value / step) * step);
}
